import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Configuration } from '../Constants/configuration';
import { CocheSeguro } from '../modelos/cocheSeguro.model';
import { StyleCocheSeguro } from '../modelos/styleCocheseguro.model';
import { RequestServices } from '../services/request.service';
import { StorageService } from '../services/storage.service';
declare var gtag;

@Component({
  selector: 'app-pago-exitoso',
  templateUrl: './pago-exitoso.component.html',
  styleUrls: ['./pago-exitoso.component.css']
})
export class PagoExitosoComponent implements OnInit {

  public sias = [
    { id: '1', tel: '800 834 3400' }, //CHUBB
    { id: '18', tel: '800 400 9000' }, //INSURGE
    { id: '22', tel: '800 849 8585' }, //MAPFRE
    { id: '29', tel: '800 288 6700' }, //QUÁLITAS
    { id: '31', tel: '800 723 4763' }, //AFIRME
    { id: '44', tel: '800' }, //ZURICH
    { id: '3', tel: '800' }, //AIG
    { id: '49', tel: '800 017 6288' }, //PRIMERO SEGUROS
    { id: '14', tel: '800 019 6000' } //HDI
  ]
  public polizaID: number;
  public tel_aseg: string;
  public proceso: string;
  public cia:string;
  public styleCocheSeguro: StyleCocheSeguro = new StyleCocheSeguro();
  public const: Configuration = new Configuration();
  public correo: string;
  public cocheSeguro: CocheSeguro;


  constructor(private route: ActivatedRoute, private router: Router, private storageService: StorageService,) {
    if (this.storageService.ifExist("styleCocheSeguro")) {
      this.styleCocheSeguro = JSON.parse(this.storageService.getItem("styleCocheSeguro"));
  }
  }


  ngOnInit(): void {
    gtag({ 'event': 'CocheSeguroPagoExitoso' });
    if(this.storageService.ifExist("cocheSeguro")){
      this.cocheSeguro = JSON.parse(this.storageService.getItem('cocheSeguro'));
      this.correo = this.cocheSeguro.prospecto.correo;
    }
    this.route.queryParams.subscribe(res => {
      this.polizaID = res.polizaId;
      this.cia = res.aseg;
      if(this.storageService.ifExist("medioPago")){
        let medioPago = JSON.parse(this.storageService.getItem('medioPago'));
        if(medioPago){
          gtag({
            'event': 'Purchase_1',
            'poliza': this.polizaID
          });
        } else {
          gtag({
            'event': 'Purchase',
            'poliza': this.polizaID
          });
        }
      }
      this.tel_aseg = this.sias.find(item => item.id === res.aseg).tel
      if(res.proceso){
        this.proceso = '¡RENOVACIÓN EXITOSA!';
      }else{
        this.proceso = '¡COMPRA EXITOSA!';
      }
    })

  }

  inicio() {
    this.storageService.removeItem('medioPago');
    if (this.const.PLATFORM) {
        window.location.href = this.const.URLPLATFORM + 'inicio';
    } else {
        this.router.navigate(['/inicio']);
    }
}

descargarPoliza() {
  if (this.storageService.ifExist("pdf")) {
     window.open(JSON.parse(this.storageService.getItem("pdf")).policy_url, '_blank');
  } else {
    if (this.cocheSeguro.m != "" && this.cocheSeguro.tkn != "") {
      this.router.navigate(['/mi-cuenta/inicio']);
    }
  }
}
descargarRecibo() {
  if (this.storageService.ifExist("recibo")) {
     window.open(JSON.parse(this.storageService.getItem("recibo")).policy_url, '_blank');
  }
}

}
